export default "__VITE_ASSET__DqUXasIO__"